import React from 'react';
import PropTypes from 'prop-types';
import * as turf from '@turf/turf';

import withStyles from '@material-ui/core/styles/withStyles';
import { Box, Grid, MenuItem, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { connect } from 'react-redux';
import { MAIN_MAP } from '../../../../../redux/map/Constants';

import SimpleHeading from '../SimpleHeading';
import SelectTextField from '../../../../Common/UI/SelectTextField';
import DrawnSearchAreaInput from './DrawnSearchAreaInput';
import FixedSearchAreaInput from './FixedSearchAreaInput';
import InputLabel from '../../../../Common/UI/InputLabel';

class SearchAreaInput extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        heading: PropTypes.string,
        // Redux State
        facets: PropTypes.array.isRequired, // list of available facets
        drawModule: PropTypes.any,
        geojson: PropTypes.object,
        facet: PropTypes.object, // current facet
        facetValue: PropTypes.string,
        maxArea: PropTypes.number.isRequired,
        // Redux Dispatch
        dispatchSetAreaFacet: PropTypes.func.isRequired,
        dispatchSetAreaFacetValue: PropTypes.func.isRequired,
        dispatchSetArea: PropTypes.func.isRequired,
        dispatchValidateAreaValueAsync: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.validate = this.validate.bind(this);
        this.getAreaInput = this.getAreaInput.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    validate () {
        const { facet, geojson, maxArea } = this.props;
        if(!facet) {
            return null;
        }
        switch (facet.layerType) {
            case 'all':
                return null;
            case 'drawn':
                if (!geojson) { return null; }
                if (turf.area(geojson.geometry) > maxArea) { return `Area is too large to perform search, please restrict area to less than ${(maxArea * 0.000001).toLocaleString(undefined, { maximumFractionDigits: 0 })} km`; }
                return null;
            case 'fixed':
                return null;
            default:
                console.error(`Unimplemented Area Type ${facet.layerType}`);
                return `Unimplemented Area Type ${facet.layerType}`;
        }
    }

    getAreaInput () {
        const { facet } = this.props;
        if(!facet) {
            return <></>;
        }
        switch (facet.layerType) {
            case 'all':
                return <></>;
            case 'drawn':
                return <DrawnSearchAreaInput {...this.props}/>;
            case 'fixed':
                return <FixedSearchAreaInput {...this.props}/>;
            default:
                console.error('Unimplemented Area Type');
                return <></>;
        }
    }

    handleChange (event) {
        const { dispatchSetAreaFacet } = this.props;
        dispatchSetAreaFacet(event.target.value);
    }

    render () {
        const { classes, heading, facets, facet, geojson } = this.props;
        const error = this.validate();
        return (
            <div className={classes.root}>
                <SimpleHeading
                    label={heading}
                />
                <Grid container spacing={2} alignContent='center' alignItems='center'>
                    <Grid item xs={4}>
                        <InputLabel label="Search Area" />
                    </Grid>
                    <Grid item xs={8}>                     
                        <SelectTextField
                            name="value"
                            value={facet ? facet.id : ''}
                            placeholder="select an option"
                            onChange={this.handleChange}
                            fullWidth
                        >
                            { facets.map(f => <MenuItem key={f.id} value={f.id}>{f?.name}</MenuItem>) }
                        </SelectTextField>
                    </Grid>
                </Grid>
                {this.getAreaInput()}
                {
                    error &&
                        <Alert severity="error">
                            {/* <AlertTitle>Error</AlertTitle> */}
                            {error}
                        </Alert>
                }
            </div>
        );
    }
}

const style = theme => ({
    root: {
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin - 5
        },
    }
});

const mapStateToProps = (state, ownProps) => {
    const reducer = state[ownProps.reducerName];
    const area = reducer[ownProps.reducerAreaKey];
    const featureLayer = state.user.features[ownProps.featureKey].layerId ?
        state.user.features[ownProps.featureKey] :
        state.user.features[ownProps.featureKey].layers.find(layer => layer.layerId === area.layerId)
    return {
        facets: featureLayer.areaFacets.map(id => state.lookups.uiData.facetChoices.find(fc => fc.id === id)),
        drawModule: state[MAIN_MAP].drawModule,
        maxArea: state.user.features[ownProps.featureKey].maxArea,
        facetValue: area.facetValue
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(SearchAreaInput));